/**
 * Profile Tour Configuration
 * Introduces users to the profile page features
 */

import { TourDefinition } from './tour.types';

export const profileTour: TourDefinition = {
  id: 'profile-tour',
  name: 'Your Profile',
  page: '/profile',
  version: 1,
  steps: [
    {
      id: 'profile-intro',
      targetSelector: '[data-tour="profile-header"]',
      title: 'Your Profile',
      description:
        'This is your personal profile page. View and update your account information, profile picture, and manage your carrier connections.',
      placement: 'bottom',
    },
    {
      id: 'profile-info',
      targetSelector: '[data-tour="profile-info"]',
      title: 'Profile Information',
      description:
        'Update your name, profile picture, contact information, and other personal details. This information is displayed throughout the app and may be visible to your agency team.',
      placement: 'bottom',
    },
    {
      id: 'profile-carriers',
      targetSelector: '[data-tour="profile-carriers"]',
      title: 'My Carriers',
      description:
        'Manage your insurance carrier connections here. Add carrier credentials to enable quoting and e-app submissions directly through the platform.',
      placement: 'top',
    },
  ],
};
